if (!customElements.get("specification-groups")) {
  customElements.define(
    "specification-groups",
    class SpecificationGroups extends HTMLElement {
      connectedCallback() {
        this.addEventListener("click", this.handleToggle);
      }

      disconnectedCallback() {
        this.removeEventListener("click", this.handleToggle);
      }

      handleToggle = (event) => {
        const toggle = event.target.closest("[data-spec-group-toggle]");
        if (!toggle || !this.contains(toggle)) return;

        const group = toggle.dataset.specGroupToggle;
        const expanded = toggle.getAttribute("aria-expanded") !== "true";

        toggle.setAttribute("aria-expanded", expanded);
        this.querySelectorAll(`[data-spec-group="${group}"]`).forEach((row) => {
          row.hidden = !expanded;
        });
      };
    },
  );
}
